// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/style/base.css'
import './assets/style/wap.scss'
import App from './App'
import BaiduMap from 'vue-baidu-map'
import plugin from './config/plugin.js'
import store from './store'
import './config/rem.js';

Vue.config.productionTip = false
Vue.use(plugin, store, router);
Vue.use(ElementUI);
Vue.use(BaiduMap, {
    ak: '4ikJmgJIxtYJq8Xxl6yJ6hPVa5cQe19q'
});
// /* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js